export default {
    API_ENDPOINT: 'http://localhost:8000/api',
    TOKEN_KEY: 'startsmall-client-auth-token'
  }